import PropTypes from 'prop-types';
import circlesStrings from 'modules/circles/strings';

import { Wrapper, SearchBarWrapper, SearchBar, SearchBarIcon } from './ClosedCirclesFilter.style';

const ClosedCirclesFilter = ({ searchQuery, handleSearchBarInputChange }) => (
  <Wrapper>
    <SearchBarWrapper>
      <SearchBarIcon />
      <SearchBar
        placeholder={circlesStrings.closedCirclesFilter.searchBarPlaceholder}
        value={searchQuery}
        onChange={handleSearchBarInputChange}
      />
    </SearchBarWrapper>
  </Wrapper>
);
ClosedCirclesFilter.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
};

export default ClosedCirclesFilter;
